import { Component, ChangeDetectionStrategy } from "@angular/core";
import { GridBaseComponent } from "../grid-base/grid-base.component";

@Component({
    selector: "rask-grid-multi-select",
    templateUrl: "./grid-multi-select.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./grid-multi-select.component.scss"]
})
export class GridMultiSelectComponent extends GridBaseComponent {

}
